import { useEffect, useState } from "react";
import useSWR from "swr";
import { useSelector } from "react-redux";
import { OpenInNew } from "@mui/icons-material";
import { Link, useParams } from "react-router-dom";
import { Alert, Box, Grid, Typography } from "@mui/material";

import API from "../../api";
import Loader from "../../components/Loader";
import ViewPage from "../../layouts/ViewPage";
import { getAccessToken } from "../../utils/user";
import LabelAndDisplay from "../../components/LabelAndDisplay";
import ImageContainer from "../../components/shared/ImageContainer";
import "./index.scss";
import { getTranslation } from "../../utils/translate";

const View = () => {
  const retailer = useSelector((state) => state.retailer);
  const user = useSelector((state) => state.user);
  const [title, setTitle] = useState("");
  const [fields, setFields] = useState([]);
  const [sidebarFields, setSidebarFields] = useState([]);
  const [data, setData] = useState({});
  const retailerId = retailer?.id;
  const isAdminUser = API.isAdmin(user);
  const barcodeId = useParams().barcodeId;
  const [, setFormData] = useState({
    code: "",
    owner: "",
    beef_product_id: "",
    raw_description: "",
    retailer: "",
    product_image: null,
    data_source: "",
    price_data: "",
    label_text: "",
  });

  const { data: barcodeData, isLoading } = useSWR({
    url: `barcode/${barcodeId}`,
    fields:
      "*,beef_product_id.*.*",
  });

  useEffect(() => {
    if (barcodeData) {
      setData(barcodeData);
      setTitle(barcodeData?.code);
    }
  }, [barcodeData]);
  useEffect(() => {
    if (data) {
      setFields([
        {
          key: "IMAGE",
          children: data?.beef_product_id?.image ? (
            <ImageContainer
              url={`${process.env.REACT_APP_API_URL}/assets/${data?.beef_product_id?.image?.id}`}
              alt="Product"
              sx={{
                height: "20rem",
              }}
            />
          ) : (
            <Alert severity="info">Product image not available.</Alert>
          ),
        },
        {
          key: "Barcode",
          value: data?.code,
        },
        {
          key: "PRODUCT",
          children: (
            <Link
              to={`/beef-cuts/${data?.beef_product_id?.id}`}
              >
              <Typography>
                {getTranslation(data?.beef_product_id, { key: "languages_id", code: "en-US" })?.name}
                <OpenInNew />
              </Typography>
            </Link>
          )
        },
      ]);
      setSidebarFields([
        {
          key: "BARCODE IMAGE",
          children: data?.barcode_image?.filename_disk ? (
            <ImageContainer
              url={`${process.env.REACT_APP_API_URL}/assets/${
                data?.barcode_image?.filename_disk
              }?access_token=${getAccessToken()}&key=`}
              alt="Barcode"
              sx={{
                height: "20rem",
              }}
            />
          ) : (
            <Alert severity="info">Barcode image not available.</Alert>
          ),
        },
      ]);
    }
  }, [data]);

  return (
    <ViewPage
      title={title}
      breadcrumbsLinks={[
        {
          url: "/codes-menu",
          content: "Codes",
        },
        {
          url: `/barcodes`,
          content: 'Barcodes',
        }
      ]}
      previewUrl={`https://${retailer.subdomain}/recipe-list?beef_cut=${data?.beef_product_id?.id}`}
    >
      <>
        {isLoading || !data ? (
          <Loader />
        ) : (
          <>
            <Box
              sx={{
                p: 0,
                mb: 3,
              }}
            >
              <Box sx={{ flexGrow: 1, mb: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={7} lg={8}>
                    <Box sx={{ flexGrow: 1, mb: 3 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          {fields.map((field) => (
                            <LabelAndDisplay
                              key={field.key}
                              label={field.key}
                              value={field.value}
                            >
                              {field.children}
                            </LabelAndDisplay>
                          ))}
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={5} lg={4}>
                    <Box sx={{ flexGrow: 1, mb: 3 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          {sidebarFields.map((field) => (
                            <LabelAndDisplay
                              direction="column"
                              key={field.key}
                              label={field.key}
                              value={field.value}
                            >
                              {field.children}
                            </LabelAndDisplay>
                          ))}
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </>
        )}
      </>
    </ViewPage>
  );
};

export default View;
